<template>
  <v-dialog v-model="dialogValue" max-width="400" lazy>
    <v-card>
      <v-form @submit.prevent="exportReport">
        <v-card-title class="headline">
          Export Pay Report
        </v-card-title>

        <v-card-text>
          <v-menu v-model="fromDateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <v-text-field slot="activator" v-model="fromDateFormatted" label="From Date" prepend-icon="event" readonly />
            <v-date-picker v-model="fromDate" color="secondary" @input="fromDateMenu = false" />
          </v-menu>

          <v-menu v-model="toDateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <v-text-field slot="activator" v-model="toDateFormatted" label="To Date" prepend-icon="event" readonly />
            <v-date-picker v-model="toDate" color="secondary" @input="toDateMenu = false" />
          </v-menu>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn flat="flat" @click="dialogValue = false">
            close
          </v-btn>

          <v-btn type="submit" color="secondary" flat="flat">
            export
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
  import moment from 'moment';

  export default {
    props: {
      data: {
        type: Object,
        default: () => { },
      },

      dialog: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      toDateMenu: false,
      fromDateMenu: false,
      fromDate: new Date().toISOString().substr(0, 10),
      toDate: new Date().toISOString().substr(0, 10),
    }),

    computed: {
      toDateFormatted() {
        return this.toDate ? moment(this.toDate).format('MMMM D, YYYY') : '';
      },

      fromDateFormatted() {
        return this.fromDate ? moment(this.fromDate).format('MMMM D, YYYY') : '';
      },

      dialogValue: {
        get() {
          return this.dialog;
        },
        set(value) {
          this.$emit('update:dialog', value);
        },
      },
    },

    watch: {
      dialogValue(val) {
        if (!val) {
          setTimeout(() => {
            this.fromDate = new Date().toISOString().substr(0, 10);
            this.toDate = new Date().toISOString().substr(0, 10);
            this.clearErrors();
          }, 300);
        }
      },
    },

    methods: {
      exportReport() {
        window.open(`/api/human-resources/payable-entity-tax-data/pay-items/${this.data.taxableEntityId}/report?fromDate=${this.fromDate}&toDate=${this.toDate}`);
        this.dialogValue = false;
      },
    },
  };
</script>